import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form, Modal, Transfer } from 'antd';
import { queryAllRoleList } from '@api/core/role';
import { queryAccountRoleRoles } from '@api/core/user';

class IndexModal extends Component {
  constructor(props) {
    super(props);
    this.state = { list: [], targetKeys: [] };
  }

  componentDidMount() {
    this.loadData();
    this.loadUserRole(this.props.accountUuid);
  }

  componentWillReceiveProps(nextProps) {
    this.props.accountUuid && nextProps.accountUuid && this.loadUserRole(nextProps.accountUuid);
  }

  loadData = () => {
    queryAllRoleList({ status: 1 }).then(res => {
      if (res.statusCode === 200) {
        this.setState({ list: res.data });
      }
    });
  };

  loadUserRole = accountUuid => {
    queryAccountRoleRoles({ accountUuid }).then(res => {
      if (res.statusCode === 200) {
        this.setState({ targetKeys: res.data.map(item => item.uuid) });
      }
    });
  };

  submit = () => {
    const { targetKeys } = this.state;
    this.props.onOk(targetKeys);
    this.loadUserRole(this.props.accountUuid);
  };

  onCancel = () => {
    this.props.form.resetFields();
    this.props.onCancel();
  };

  onChange = value => {
    this.setState({ targetKeys: value });
  };

  render() {
    const { list, total, pageNo, targetKeys } = this.state;

    const pagination = {
      showSizeChanger: false,
      pageSize: 15,
      total,
      current: pageNo,
      onChange: current => {
        this.loadData(current);
      },
      showTotal: showTotal => {
        return `共 ${showTotal} 条`;
      },
    };
    return (
      <Modal
        title="角色授权"
        visible={this.props.visible}
        onOk={this.submit}
        onCancel={this.onCancel}
      >
        <Transfer
          rowKey={record => record.uuid}
          dataSource={list}
          titles={['Source', 'Target']}
          targetKeys={targetKeys}
          onChange={this.onChange}
          render={item => item.name}
          pagination={pagination}
        />
      </Modal>
    );
  }
}

export default connect(state => ({
  accountInfo: state.account_info,
}))(Form.create()(IndexModal));



// WEBPACK FOOTER //
// ./src/components/boss/user/ModalUserRoleAdd.js